import logger from "@next/core-logger"
import {externalCallAxiosInstance as axios} from "../../utils/axios"
import {isRelativePath} from "../../utils/configUrlPath"

export const getMessageBannerData = async (
    baseUrl: string,
    path: string,
    tokenName: string | undefined,
    tokenValue: string | undefined,
    realm: string,
    territory: string,
    language: string,
    siteUrl: string,
): Promise<any> => {
    try {
        const constructedPath = path
            .replace("<realm>", `${realm}`)
            .replace("<territory>", `${territory}`)
            .replace("<language>", `${language}`)
        const accessHeaders = tokenName && tokenValue ? {[tokenName]: tokenValue} : {}
        const constructedBaseUrl = isRelativePath(baseUrl)
            ? `${siteUrl.replace(new URL(siteUrl).origin, "")}${baseUrl}`
            : baseUrl
        const response = await axios.get(`${constructedBaseUrl}${constructedPath}`, {headers: {...accessHeaders}})
        return response.data
    } catch (ex) {
        logger.error(ex)
        throw ex
    }
}
